import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

interface KeywordDeleteConfirmProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  keyword: string;
}

const KeywordDeleteConfirm: React.FC<KeywordDeleteConfirmProps> = ({
  open,
  onConfirm,
  onCancel,
  keyword,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="warning" />
          Smazat klíčové slovo?
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Opravdu chcete smazat toto klíčové slovo?
        </Typography>
        <Typography variant="h6" color="primary" sx={{ my: 2, fontWeight: 'bold' }}>
          "{keyword}"
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Tato akce je nevratná. Všechny statistiky použití budou ztraceny.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          Zrušit
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error" autoFocus>
          Smazat
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default KeywordDeleteConfirm;

